import { useState } from 'react'
import { FilterProps, useAsyncDebounce } from 'react-table'
import { TextField } from '@mui/material'
import { EnhancedHeader } from '../../../../types'

interface Props<D extends object> extends FilterProps<D> {
  column: EnhancedHeader<D>
  columns: EnhancedHeader<D>[]
}

export default function TextFilter<D extends object>({ column: { filterValue, setFilter } }: Props<D>) {
  const [value, setValue] = useState(filterValue || '')
  const onChange = useAsyncDebounce((value) => {
    setFilter(value || undefined)
  }, 300)
  return (
    <TextField
      fullWidth
      size="small"
      label="Filter Value"
      value={value}
      onChange={(evt: any) => {
        setValue(evt.target.value)
        onChange(evt.target.value)
      }}
    />
  )
}
